import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IAppUserState }        from 'Redux/Slices/AppUser/AppUserSlice';
import { AppUser }              from 'Domain/Models';
import { PayloadActionList }    from 'Utils';
import { removeActionTypes }    from 'Utils/ReducerUtility';


export const findAppUsersRequest = (state: Draft<IAppUserState>, { type }: PayloadActionList) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findAppUsersSuccess = (state: Draft<IAppUserState>, { type, payload }: PayloadAction<{
  appUsers: Record<string, AppUser>,
  maxCount: number,
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = payload.appUsers;
  state.maxCount = payload.maxCount ?? state.maxCount;

};

export const findAppUsersFailure = (state: Draft<IAppUserState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
